import { render, staticRenderFns } from "./collectionRateDetailStatistics.vue?vue&type=template&id=4fe5a444&"
import script from "./collectionRateDetailStatistics.vue?vue&type=script&lang=js&"
export * from "./collectionRateDetailStatistics.vue?vue&type=script&lang=js&"
import style0 from "./collectionRateDetailStatistics.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports